import { usePermissionRequest } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper.tsx';
import { PermissionRole, ResourceType } from '@dealstack/shared/lib/generated/index.ts';
import { defaultToEmptyString } from '@dealstack/shared/lib/format/string.ts';
import { useParams } from 'react-router-dom';
import { useMasterDocumentsScope } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/MasterDocumentsScopeContext.tsx';

export const useContractsPermissions = () => {
	const { organizationId } = useMasterDocumentsScope();
	const { mipId } = useParams();

	// Editing an organisation's Programme Defaults is an organisation-admin right, not a
	// programme one.
	const { hasPermission } = usePermissionRequest(
		organizationId
			? {
					resourceType: ResourceType.ORGANIZATION,
					resourceId: organizationId,
					permissionRole: PermissionRole.ADMIN,
				}
			: {
					resourceType: ResourceType.PROGRAMME,
					resourceId: defaultToEmptyString(mipId),
					permissionRole: PermissionRole.EDITOR,
				}
	);

	return { hasPermission };
};
